module.exports = __webpack_public_path__ + "src/assets/animations/lavender.txt";


//////////////////
// WEBPACK FOOTER
// ./src/assets/animations/lavender.txt
// module id = ./src/assets/animations/lavender.txt
// module chunks = 0